import React, { useRef, useEffect, useState } from "react";
import ItConsulting from "./../image/healthcare.png";
import { Link } from "react-router-dom";

const HomeCaseStudies = () => {
  const scrollContainerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(1);

  const slides = [
    {
        image: ItConsulting,
        title: "Healthcare Consulting",
        description:
          "We provide strategic IT consulting for healthcare, including holistic assessments, risk management, and technology roadmaps. Our expertise ensures seamless system integration, compliance with regulations, and scalable digital transformation. Leveraging AI and data-driven insights, we enhance patient-centric care and operational efficiency while maintaining top-tier security standards.",
    }   ,  
    
  ];

  useEffect(() => {
    // Detect screen width to determine slides per view
    const updateSlidesPerView = () => {
      if (window.innerWidth >= 1024) {
        setSlidesPerView(2); // Show 2 slides on large screens
      } else {
        setSlidesPerView(1); // Show 1 slide on small screens
      }
    };

    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);
    return () => window.removeEventListener("resize", updateSlidesPerView);
  }, []);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let currentIndex = 0;
    const totalSlides = Math.ceil(slides.length / slidesPerView);
    const boxWidth = scrollContainer.clientWidth;

    const autoScroll = () => {
      currentIndex = (currentIndex + 1) % totalSlides;
      setActiveIndex(currentIndex);
      scrollContainer.scrollTo({
        left: currentIndex * boxWidth,
        behavior: "smooth",
      });
    };

    const scrollInterval = setInterval(autoScroll, 3000);

    return () => clearInterval(scrollInterval);
  }, [slides.length, slidesPerView]);

  return (
    <div className="bg-gray-900 text-white w-full h-auto flex flex-col items-center justify-center lg:px-20 lg:py-20 px-5 py-10">
      <div className="w-full">
        {/* Heading */}
        <div className="mb-5 text-left">
          <h2 className="text-3xl font-semibold">Industry Expertise</h2>
          <p className="text-lg">
            Explore how we've helped our clients achieve their goals through
            innovative solutions and strategic partnerships.
          </p>
        </div>

        {/* Case Studies Container */}
        <div className="relative w-full">
          <div
            ref={scrollContainerRef}
            className="flex overflow-hidden scroll-smooth"
            style={{ width: "100%", display: "flex", gap: "20px" }}
          >
            {slides.map((slide, index) => (
             <div
             key={index}
             className="lg:w-[48%] w-[90%] flex-shrink-0 bg-gray-800 p-5 rounded-lg shadow-lg flex flex-col justify-between"
             style={{ minWidth: "48%" }}
           >
             <div>
               <img
                 src={slide.image}
                 alt={slide.title}
                 className="w-full h-60 object-fill rounded-lg"
               />
               <h3 className="text-xl font-semibold mt-3">{slide.title}</h3>
               <p className="text-md mt-2">{slide.description}</p>
             </div>

             <div className="mt-4 flex justify-center">
  <Link to="/case-studies">
    <button   className="bg-gradient-to-r from-blue-500 to-purple-600 text-white hover:from-purple-600 hover:to-blue-500 transition duration-300 px-6 py-2 rounded-md text-[15px] shadow-md 
                        hover:scale-105">
      Know More
    </button>
  </Link>
</div>

           </div>
            ))}
          </div>
        </div>

        {/* Dots & Button Container */}
        <div className="relative mt-5 flex flex-col items-center gap-3">
          {/* Slide Dots */}
          <div className="flex gap-2">
            {Array(Math.ceil(slides.length / 2))
              .fill()
              .map((_, index) => (
                <span
                  key={index}
                  onClick={() =>
                    scrollContainerRef.current.scrollTo({
                      left: index * scrollContainerRef.current.clientWidth,
                      behavior: "smooth",
                    })
                  }
                  className={`w-3 h-3 rounded-full cursor-pointer transition-all ${
                    index === activeIndex ? "bg-white scale-110" : "bg-gray-500"
                  }`}
                ></span>
              ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default HomeCaseStudies;
